import type { PredictionContract } from '@/services/prediction/types'

/**
 * Port of cdc-web `src/components/knockOuts/helpers/utils.ts` 的
 * `parseMatchEventContracts`（1:1，含 OG-5916 同队去重修复）。
 */
export const parseMatchEventContracts = (
  contracts: PredictionContract[] | null | undefined,
): {
  drawContract?: PredictionContract
  leftContract?: PredictionContract
  rightContract?: PredictionContract
  normalContracts: PredictionContract[] | undefined
} => {
  const drawContract = contracts?.find(contract => contract.prediction_outcome_type === 'Draw')

  const normalContracts = contracts?.filter(contract => contract.prediction_outcome_type !== 'Draw')

  // Some match-event moneyline sections (e.g. MMA) ship multiple contracts
  // for the SAME competitor — different durations/symbols of the same
  // outcome. Naively taking [0] and [1] then yields the same competitor on
  // both sides, surfacing as the right-competitor-equals-left bug
  // (OG-5916). Dedupe by `team_id` to collapse those duplicates while
  // preserving original order. Prefer the contract that carries pricing
  // (yes/chance present) so the left/right card buttons remain tradable.
  const uniqueByTeam = (normalContracts ?? []).reduce<PredictionContract[]>((acc, contract) => {
    const existingIndex = contract.team_id ? acc.findIndex(c => c.team_id === contract.team_id) : -1
    if (existingIndex === -1) {
      acc.push(contract)
      return acc
    }
    const existing = acc[existingIndex]
    const existingHasQuote = !!existing.yes && !!existing.chance
    const candidateHasQuote = !!contract.yes && !!contract.chance
    if (!existingHasQuote && candidateHasQuote) {
      acc[existingIndex] = contract
    }
    return acc
  }, [])

  return {
    drawContract,
    leftContract: uniqueByTeam[0],
    rightContract: uniqueByTeam[1],
    normalContracts,
  }
}
